import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { UpdateSeriesInput, VideoSeriesProps } from "../store/actionType";
import {
  CreateFolderInput,
  CreateFolderError,
} from "modules/video/components/DataType";
import { CreateFolderForm } from "modules/video/components/CreateFolderForm";
import { updateVideoSeries } from "../store/action";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";

interface EditSeriesProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  seriesData: VideoSeriesProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & EditSeriesProps;

const EditSeries: React.FC<Props> = ({
  closeModal,
  seriesData,
  onUpdateVideoSeries
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CreateFolderInput>({
    title: seriesData.title || "",
    series_order: seriesData.series_order ,
  });
  const [error, setError] = useState<CreateFolderError>({});
  const [apiError, setApiError] = useState(null);
  const seriesState = useSelector(
    (state: any) => state.videoSeries?.videoSeriesState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: UpdateSeriesInput = {
      title: formData.title,
      series_order: formData.series_order,
      // category_id: seriesData.id,
      folder_id: seriesData.folder_id,
      series_id: seriesData.id

    }
     if (formData.title.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        title: "Series Title is required",
      }));
    }
    if (formData.series_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        series_order: "Order is required",
      }));
    }
    if (formData.title.trim() !== "" && formData.series_order !== null) {
      setLoading(true);
      onUpdateVideoSeries(input)
      setSubmitted(true);
      setLoading(false);
    }
  };
   useEffect(() => {
      if (!seriesState.isLoading && submitted) {
        if (seriesState.error) {
          setApiError(seriesState.error); // show error
        } else {
          setApiError(null);
          closeModal(false);
        }
      }
    }, [seriesState.isLoading, seriesState.error, submitted, closeModal]);
  return (
    <>
      <CreateFolderForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        formErrors={error}
        loading={loading}
        header={"Create Series"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) =>({
  onUpdateVideoSeries: (input:UpdateSeriesInput) =>
    dispatch(updateVideoSeries(input))
})

export default connect(null, mapDispatchToProps)(EditSeries)